import { memo, useState } from 'react'
import { pick } from 'lodash-es'
import { IconEdit } from '@tabler/icons'
import { fieldFilter } from '@ow/ditto-core'
import { Button } from '@ow/comps'
import { useDetailStore, useTbViewStore } from '@vt/hooks'

const Edit = ({ onClickSubmit }) => {
  const [loading, setLoading] = useState(false)
  const [isEditing, setIsEditing] = useState(false)

  const { fields } = useTbViewStore((state) => pick(state, ['fields']))
  const { setEditableSlugs } = useDetailStore((state) =>
    pick(state, ['setEditableSlugs'])
  )

  const onEdit = () => {
    // setIsReCreate(true)
    setIsEditing(true)
    setEditableSlugs(
      fields
        .filter((field) => fieldFilter(field) && !field.hiddenWhenCreate)
        .map((field) => field.slug)
    )
  }

  const cancel = () => {
    setEditableSlugs([])
    setIsEditing(false)
  }

  const submit = () => {
    setLoading(true)
    onClickSubmit(
      () => {
        cancel()
        setLoading(false)
      },
      () => {
        setLoading(false)
      }
    )
  }

  if (isEditing) {
    return (
      <>
        <Button type="primary" loading={loading} onClick={submit}>
          保存
        </Button>
        <Button stroke onClick={cancel}>
          取消
        </Button>
      </>
    )
  }

  return (
    <IconEdit
      className="cursor-pointer hover:opacity-60"
      stroke="grey"
      onClick={onEdit}
    />
  )
}

export default memo(Edit)
